<template>
  <el-table-column
    v-if="JSON.stringify(column.form_type).indexOf('icon') != -1 && column.is_hide === '0'"
    :sortable="column.is_sort === '0' ? false : true"
    :prop="column.field"
    :label="column.name"
    align="center"
    show-overflow-tooltip
  >
    <template #default="scope">
      <el-tag :type="scope.row[column.field] instanceof Object?scope.row[column.field].key:0 | statusFilter">{{scope.row[column.field] instanceof Object ? scope.row[column.field].value : scope.row[column.field]}}</el-tag>
    </template>
  </el-table-column>
  <el-table-column
    v-else-if="JSON.stringify(column.form_type).indexOf('link') != -1 && column.is_hide === '0'"
    :sortable="column.is_sort === '0' ? false : true"
    :prop="column.field"
    :label="column.name"
    align="center"
    show-overflow-tooltip
  >
  <template #default="scope">
      <el-link type="primary" @click="linkClick(scope.row)">{{scope.row[column.field] instanceof Object ? scope.row[column.field].value : scope.row[column.field]}}</el-link>
    </template>
  </el-table-column>
<el-table-column
    v-else-if="JSON.stringify(column.form_type).indexOf('text') != -1 && column.is_hide === '0'"
    :sortable="column.is_sort === '0' ? false : true"
    :prop="column.field"
    :label="column.name"
    align="center"
    show-overflow-tooltip

  >
  <template #default="scope">
      {{scope.row[column.field] instanceof Object ? scope.row[column.field].value : scope.row[column.field]}}
    </template>
  </el-table-column>
  <el-table-column
    v-else-if="JSON.stringify(column.form_type).indexOf('selectCity') != -1 && column.is_hide === '0'"
    :sortable="column.is_sort === '0' ? false : true"
    :prop="column.field"
    :label="column.name"
    :formatter="getCityName"
    align="center"
    show-overflow-tooltip
  />
  <el-table-column
    v-else-if="JSON.stringify(column.form_type).indexOf('select') != -1 && column.is_hide === '0'"
    :sortable="column.is_sort === '0' ? false : true"
    :prop="column.field"
    :label="column.name"
    :formatter="getChannelName"
    align="center"
    show-overflow-tooltip
  >
   <template #default="scope">
      <el-tag type="">{{scope.row[column.field] instanceof Object ? scope.row[column.field].value : scope.row[column.field]}}</el-tag>
    </template>
  </el-table-column>
  <el-table-column
    v-else-if="column.is_hide === '0'"
    :sortable="column.is_sort === '0' ? false : true"
    :prop="column.field"
    :label="column.name"
    align="center"
    show-overflow-tooltip
  />

</template>

<script>
export default {
  name: 'seatslist',
  components: {},
  filters: {
    statusFilter(status) {
      const statusMap = {
        0: '',
        1: 'warning',
        2: 'warning',
        3: 'warning',
        4: 'warning',
        5: 'warning'
      }
      return statusMap[status]
    }
  },
  props: {
    column: {
      type: Object
    },
    handlecellSelectBack: {
      type: Function
    }
  },
  data() {
    return {}
  },
  methods: {
    getChannelName(row, column, cellValue, index) {
      return cellValue.value
    },
    getCityName(row, column, cellValue, index) {
      return cellValue
    },
    linkClick(item) {
      this.handlecellSelectBack(item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Table/tablecell.vue